import React from 'react';
import { bool, shape, string } from 'prop-types';

const ChevronLeft = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.705 7.41L14.295 6L8.29498 12L14.295 18L15.705 16.59L11.125 12L15.705 7.41Z" fill="currentColor" />
  </svg>
);

ChevronLeft.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ChevronLeft;
